export const Menu = () => {
    return (
        <section className="menu">
            <h1>התפריט של טלי</h1>
            <h2>אוכל ביתי לסופי שבוע, לאירועים או סתם כדי להתפנק</h2>
            <section className="menu-container">
                <img alt="menu" src={require('../assets/imgs/menu.png')} />
            </section>
        </section>
    );
};